import { generateGetAction, generatePostAction } from '@services/ActionDispatcher';

import {
  createNotificationAction,
  getNotificationAction,
} from './NotificationActionConfig';

const getNotificationRequest = (id: any) => generateGetAction(
  getNotificationAction,
  `notification/${id}`,
);

const createNotificationRequest = (id: any, data: any) => generatePostAction(
  createNotificationAction,
  `notification/${id}/update`,
  data,
);

export {
  getNotificationRequest,
  createNotificationRequest,
};
